import { capitalizeFirstLetter } from '~/core/service/googleMaps/utils';

export function getFirstAndLastName(name?: string | null): string[] {
	const names = name?.trim().split(/\s+/).filter(Boolean) ?? [];

	if (!names.length) return [];

	const firstAndLast = names.length > 1 ? [names[0]!, names.at(-1)!] : names;

	return firstAndLast.map(capitalizeFirstLetter);
}

export function getNameInitials(name?: string | null): string {
	return getFirstAndLastName(name)
		.map(part => part.charAt(0))
		.join('')
		.toUpperCase();
}
